import { Container, Grid } from "@mui/material";
import ScreenBanner from "../../components/ScreenBanner";
import ListaAcoesRapidas, { TItemAcaoRapida } from "../../components/ListaAcoesRapidas";
import { useNavigate } from "react-router";
import ListOutlinedIcon from '@mui/icons-material/ListOutlined';
import PermissionGuard, { usePermission } from "../../components/PermissionGuard";

export default function Cadastros() {

    const navigate = useNavigate();
    
    const listaAcoesRapidas: Array<TItemAcaoRapida> = [
        {
            label: "Listar cooperados",
            icon: <ListOutlinedIcon color="primary" />,
            action: () => navigate('/cadastros/cooperado/listar-todos'),
            havePermission: usePermission('cadastros.cooperado.listar-todos')
        },
        {
            label: "Listar clientes",
            icon: <ListOutlinedIcon color="primary" />,
            action: () => navigate('/cadastros/cliente/listar-todos'),
            havePermission: usePermission('cadastros.cliente.listar-todos')
        },
        {
            label: "Listar fornecedores",
            icon: <ListOutlinedIcon color="primary" />,
            action: () => navigate("/cadastros/fornecedor/listar-todos"),
            havePermission: usePermission("cadastros.fornecedor.listar-todos")
        },
        {
            label: "Listar empregados",
            icon: <ListOutlinedIcon color="primary" />,
            action: () => navigate("/cadastros/empregado/listar-todos"),
            havePermission: usePermission("cadastros.empregado.listar-todos")
        },
        {
            label: "Listar lojas",
            icon: <ListOutlinedIcon color="primary" />,
            action: () => navigate("/cadastros/loja/listar-todas"),
            havePermission: usePermission("cadastros.loja.listar-todas")
        }
    ]

    return (
        <>
            <ScreenBanner title="Cadastros" />

            <PermissionGuard permissionId="cadastros.dashboard">
                <Container>
                    <Grid container spacing={2} mt={2}>
                        <Grid size={{xs: 12, md: 4}}>
                            <ListaAcoesRapidas
                                items={listaAcoesRapidas}
                            />
                        </Grid>

                        <Grid size={{xs: 12, md: 8}}>
                            {/* <CardDadosDashboard /> */}
                        </Grid>

                        <Grid size={{xs: 12, md: 6}}>
                            {/* <CardCobrancas /> */}
                        </Grid>

                        <Grid size={{xs: 12, md: 6}}>
                            {/* <CardFluxoCaixa /> */}
                        </Grid>
                    </Grid>
                </Container>
            </PermissionGuard>
        </>
    )
}